module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8e7cb60d08d6316d55de80f880f1957c.gif";